import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import consts from '@/store/common/consts'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/src/styles/main.sass'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },

  theme: {
    themes: {
      light: consts.THEME_VKB
    },
    options: {
      customProperties: true
    }
  }
})
